<div class="boardWrap">
  <div class="titleBlock">
    <h4 class="text-center">Welcome to Confe.io</h4>
    <p>
      A workspace in Confe.io is your dedicated hub for connecting and managing all your social
      media accounts. It helps you streamline activities and track engagement efficiently.
    </p>
  </div>

  <form [formGroup]="workSpaceForm" class="form">
    <h4>Create Workspace</h4>

    <div class="inputRow">
      <div class="p-float-label">
        <input formControlName="workspace" pInputText id="username" />
        <label for="username">Workspace Name</label>
      </div>
    </div>
  </form>
  <p-button
    [disabled]="workSpaceForm.invalid || isLoading"
    styleClass="blueBtn"
    label="Create & Next"
    (click)="submit()"
  >
    <ng-template pTemplate="icon">
      <i *ngIf="isLoading" class="pi pi-spin pi-spinner"></i>
    </ng-template>
  </p-button>

  <p-button
    [disabled]="isLoading"
    styleClass="blueBtn skipBtn"
    label="Skip onboarding"
    (click)="skipOnboarding()"
  >
    <ng-template pTemplate="icon">
      <i class="pi pi-angle-right"></i>
      <!--<i *ngIf="isLoading" class="pi pi-spin pi-spinner"></i>-->
    </ng-template>
  </p-button>
</div>
